import type { StatusTone } from '@/components/shell/StatusChip';
import type { TenantStatus } from '@/api/models';

/** Maps a tenant's status to one of the theme's five badge tones (foundations.md §7.8). */
export function tenantStatusTone(status: TenantStatus): StatusTone {
  return status === 'active' ? 'success' : 'warning';
}
